import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { makeCygnusApiCall } from "../../api/api";
import moment from "moment/moment";

const AzureLogsDashboard = ({ startDate, endDate, onFlowSelect }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChartClick = (FlowOrchestratorId, flowName, status) => {
    if (onFlowSelect) {
      onFlowSelect(FlowOrchestratorId, flowName, status);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await makeCygnusApiCall({
        type: "POST",
        payload: {
          start_date: moment(startDate).format("YYYY/MM/DD"),
          end_date: moment(endDate).format("YYYY/MM/DD"),
        },
        url: "/status/firm_flow_run_status/",
        show_message: false,
        customized_success_message: "Loading dashboard",
        customized_failure_message: "Unable to fetch details",
        customized_error_message: "Error occurred while fetching dashboard, please contact support and attach a screenshot.",
        isblob: false,
      });

      if (response.success) {
        setData(Object.entries(response.data));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <h6>Loading your data...</h6>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "20px" }}>
          {data.map(([flowId, flow], index) => {
            const totalLogs = (flow.logs.S ?? 0) + (flow.logs.F ?? 0)
            const chartOptions = {
              chart: { type: "pie" },
              title: { text: flow.flowName },
              subtitle: { 
                text: `Total: ${totalLogs}`,
                style: { fontSize: "20px", color: "#666"},
                align: "center",
                verticalAlign: "bottom", 
                y: 30,
              },
              tooltip: {
                pointFormat: "{point.y}",
              },

              plotOptions: {
                pie: {
                  dataLabels: {
                    enabled: true,
                    style: {
                      fontSize: "18px",
                      color: "#333",
                    },
                    format: "{point.name}: {point.y}",
                    center: ["50%", "50%"],
                    size: "100%",
                  },
                  point: {
                    events: {
                      click: function () {
                        handleChartClick(flow.FlowOrchestratorId, flow.flowName, this.name);
                      },
                      style: {
                color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
            }
                    },
                  },
                  showInLegend: true,
                },
              },

              series: [
                {
                  colorByPoint: true,
                  data: [
                    {
                      name: `Success`,
                      y: flow.logs.S,
                      color: "#64E572",
                      showInLegend: true,
                    },
                    {
                      name: `Failure`,
                      y: flow.logs.F,
                      color: "#ED561B",
                      showInLegend: true,
                    },
                    // {
                    //   name: `Total: ${totalLogs}`,
                    //   y: totalLogs,
                    //   color: "#000000",
                    //   showInLegend: true,
                    //   visible: false, // Hidden in the chart but still in legend
                    // },
                  ],
                    dataLabels: {
                      enabled: true,
                      formatter: function () {
                        if (this.point.name === "Success" || this.point.name === "Failure") return null;
                        return `<b>Total Logs:</b> ${totalLogs}`;
                      },
                      style: { fontSize: "16px", fontWeight: "bold", color: "#000" },
                      align: "center",
                      verticalAlign: "middle",
                    },
                },
              ],

              legend: {
                enabled: true,
                align: "center",
                verticalAlign: "bottom",
                layout: "horizontal",
                x: 0,
                y: 20,
                style: {
                  fontSize: "18px",
                },
              },
            };

            return (
              <div key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <HighchartsReact highcharts={Highcharts} options={chartOptions} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AzureLogsDashboard;
